export default "__VITE_ASSET__C6UZ7exa__"